/**
 * Fire the event "onSbmArchiveProductCheckFilter".
 * @param {int} action - 1 to add a filter to selected filters list, 0 to remove a filter from this list, -1 to remove all filters
 * @param {int|null} filterId
 * @param {object|null} filter
 */
export const fireCheckFilterEvent = (
  action,
  filterId = null,
  filter = null
) => {
  const possibleActions = [-1, 0, 1];
  if (possibleActions.includes(action)) {
    document.dispatchEvent(
      new CustomEvent("onSbmArchiveProductCheckFilter", {
        detail: { action, id: filterId, filter },
      })
    );
  }
};

/**
 * Fire the event "onSbmArchiveProductTotal".
 * @param {int} total
 */
export const fireTotalProductEvent = (total) => {
  document.dispatchEvent(
    new CustomEvent("onSbmArchiveProductTotal", {
      detail: { total },
    })
  );
};

/**
 * Fire the event "onSbmArchiveProductCloseFiltersPannel".
 */
export const fireCloseFiltersPannel = () => {
  document.dispatchEvent(
    new CustomEvent("onSbmArchiveProductCloseFiltersPannel", {
      detail: false,
    })
  );
};

/**
 * Generate URL to go to when clicking on a filter.
 * @param {int|bool} filterId
 * @param {bool}     isActive
 * @return {string}
 */
export const generateFilterUrl = (filterId, isActive) => {
  // Get current filters in url params
  const urlParams = new URLSearchParams(window.location.search);
  const currentFilters = urlParams.get("filters");
  let filters = currentFilters ? currentFilters.split(",") : [];

  if (isActive) {
    // Remove current filter from the list
    filters = filters.filter((value) => parseInt(value) !== filterId);
  } else {
    // Add current filter to the list
    if (!filters.includes(filterId.toString())) {
      filters.push(filterId);
    }
  }

  // Update filters
  urlParams.set("filters", filters);
  if (filters.length === 0) {
    urlParams.delete("filters");
  }

  // Remove "page" param if exist to arrive on first filtered page
  if (urlParams.has("page")) {
    urlParams.delete("page");
  }

  // Return new url
  if (urlParams.toString()) {
    return `${window.location.pathname}?${urlParams}`;
  }
  return window.location.pathname;
};
